export const SEVERITY_LEVEL = {
  0: "critical",
  1: "critical",
  2: "critical",
  3: "critical",
  4: "warning",
  5: "warning",
  6: "info",
  7: "info",
}

export const EVENTS_LOG_EVENTS_TYPE = {
  SYSTEM_AUDIT: "System Audit",
  DEVICE_ONLINE: "Device Online",
  DEVICE_OFFLINE: "Device Offline",
  REGISTRATION_EVENT: "Device Registration",
  FW_UPGRADE_PROGRESS: "Firmware upgrade started",
  FW_UPGRADE_SUCCEEDED: "Firmware upgraded",
  FW_UPGRADE_FAILED: "Firmware upgrade failed",
  CL_EVENT_CLIENT_AUTH_PASS: "Client Authentication Succeeded",
  CL_EVENT_CLIENT_AUTH_FAIL: "Client Authentication Failed",
  CL_EVENT_CLIENT_JOIN: "Client Association",
  CL_EVENT_CLIENT_IPADDR_CHANGE: "Client IP change",
  CL_EVENT_CLIENT_LEAVE: "Client Disassociation",
  CL_EVENT_IPADDR_CHANGE: "IP Address Change",
  CL_EVENT_CHANNEL_CHANGE: "Channel Change",
  CL_EVENT_SW_PORT_LINKUP: "Port Status",
  CL_EVENT_SW_PORT_LINKDOWN: "Port Status",
  CL_EVENT_SW_PORT_ERROR: "Port Error",
  CL_EVENT_SW_PORT_ERROR_RECOVER: "Port Error Recovery",
  PROXY_SSH_AUTH_FAILED: "SSH Connection",
  PROXY_SSH_TIMEOUT: "SSH Connection",
  PROXY_SSH_REJECT: "SSH Connection",
  PROXY_SSH_FAILED: "SSH Connection"
}

export const EVENTS_LOG_ERROR_TYPE = {
  0: "PoE System Overload Denied",
  1: "PoE denied",
  2: "LACP abnormal",
  3: "Authentication failed",
  4: "STP discarding",
  5: "Port loop",
  7: "Port disabled manually",
}

export const EVENTS_LOG = {
  // System Audit
  device_synced: "The device <DeviceNameWithMACAsLink> had its configuration synced successfully.",
  device_sync_failed: "The device <DeviceNameWithMACAsLink> failed to sync configuration.",
  device_fw_upgrade_schedule_create: "The upgrade schedule for model series <ModelName> was created, setting the upgrade window to <NewUpgradeWindow>.",
  device_fw_upgrade_schedule_cancel: "The upgrade schedule for model series <ModelName> was canceled.",
  device_fw_upgrade_schedule_change: "The upgrade schedule for model series <ModelName> was changed from version <OldVersion> to <NewVersion> with policy <NewUpgradeWindow>.",
  invite_user_org: "User <ChangedAccountNameWithUniqueLink> was invited to organization <Org> by account <AccountNameWithUniqueLink>.",
  invite_user_site: "User <ChangedAccountNameWithUniqueLink> was invited to site <Site> in organization <Org> by account <AccountNameWithUniqueLink>.",
  remove_user_org: "User <ChangedAccountName> was removed organization <Org> by account <AccountNameWithUniqueLink>.",
  remove_user_site: "User <ChangedAccountName> was removed from site <Site> in organization <Org> by account <AccountNameWithUniqueLink>.",
  user_leave_org: "User <ChangedAccountName> left site <Site> in organization <Org>.",
  user_leave_site: "User <ChangedAccountName> left organization <Org>.",
  change_user_privilege: "User <ChangedAccountNameWithUniqueLink>'s privilege changed by account <AccountNameWithUniqueLink>.",
  captive_portal_created: "Captive portal configuration <PortalName> was created by account <AccountNameWithUniqueLink>.",
  captive_portal_changed: "Captive portal configuration <PortalName> was changed by account <AccountNameWithUniqueLink>.",
  captive_portal_delete: "Captive portal configuration <PortalName> was deleted by account <AccountNameWithUniqueLink>.",
  device_adopt: "Device <DeviceNameWithMACAsLink> is being adopt by account <AccountNameWithUniqueLink>.",
  device_removed: "Device <DeviceName> was removed by account <AccountNameWithUniqueLink>.",
  device_moved: "Device <DeviceNameWithMACAsLink> was migrated from site <OldSite> to site <NewSite> by account <AccountNameWithUniqueLink>.",
  wireless_created: "Wireless network <WirelessNetworkName> were created by account <AccountNameWithUniqueLink>.",
  wireless_deleted: "Wireless network <WirelessNetworkName> were deleted by account <AccountNameWithUniqueLink>.",
  wireless_changed: "Wireless network <WirelessNetworkName> were changed by account <AccountNameWithUniqueLink>.",
  device_radio_changed: "Radio settings for device <DeviceNameWithMACAsLink> changed  by account <AccountNameWithUniqueLink>.",
  device_network_changed: "Management interface for device <DeviceNameWithMACAsLink> changed  by account <AccountNameWithUniqueLink>.",
  org_time_zone_changed: "Time zone settings for organization were updated by account <AccountNameWithUniqueLink>.",
  site_time_zone_changed: "Time zone settings for site <Site> were updated by account <AccountNameWithUniqueLink>.",
  device_info_changed: "Device information for <DeviceNameWithMACAsLink> changed from <OldDeviceInfo>\n\nto <NewDeviceInfo>\n\nby account <AccountNameWithUniqueLink>.",
  wired_port_changed: "Wired port settings on device <DeviceNameWithMACAsLink> changed from <OldWiredSettings>\n\nto <NewWiredSettings>\n\nby account <AccountNameWithUniqueLink>.",
  port_profile_changed: "Port profile changed from <OldPortProfile>\n\nto <NewPortProfile>\n\nby account <AccountNameWithUniqueLink>.",
  duplicated_device_connection: "The device <RejectDeviceId> with <DeviceNameWithMACAsLink> coming from IP <RejectDeviceIp> registering, is now conflicting with <OldDeviceId> coming from IP <OldDeviceIp>.  Former is rejected.",
  // ap
  // device 上線, 由 sentry 通知
  ap_online: "Access point <DeviceNameWithMACAsLink> is now online.",
  // device 斷線, 由 sentry 通知
  ap_offline: "Access point <DeviceNameWithMACAsLink> is now offline.",
  // device 完成註冊, 由 sentry 通知
  ap_adopt: "Access point <DeviceNameWithMACAsLink> is now adopt.",
  // Device 開始執行 fw upgrade(下載fw, 寫進flash...)
  ap_firmware_progress: "Access point <DeviceNameWithMACAsLink> upgrading.",
  // Device 完成 fw upgrade 
  ap_firmware_success: "Access point <DeviceNameWithMACAsLink> upgraded to <FWver>.",
  // Device fw upgrade 失敗
  ap_firmware_fail: "Access point <DeviceNameWithMACAsLink> upgrade failed.",
  // wifi client 成功連上 wifi 後, 通過 CP 驗證
  ap_client_auth_pass: "Client <ClientNameWithMACAsLink> authenticated at <DeviceNameWithMACAsLink> as user <Username>.; Manufacturer: {Client Manufacturer name}; Auth: {reasonCode}",
  // wifi client 成功連上 wifi 後, 要進行 CP 驗證的時候失敗
  ap_client_auth_fail: "Client <ClientNameWithMACAsLink> authentication failed at <DeviceNameWithMACAsLink> as user <Username>.; Manufacturer: {Client Manufacturer name}; Auth: {reasonCode}",
  //  wifi client 成功連上wifi
  ap_client_joined: "Client <ClientNameWithMACAsLink> associated to <DeviceNameWithMACAsLink> with IP <ClientIpAddress>.; Manufacturer: {Client Manufacturer name}; Auth: {reasonCode}",
  // wifi client ip 改變
  ap_client_ip_changed: "Client <ClientNameWithMACAsLink> IP changed to <ClientIpAddress>.; Manufacturer: {Client Manufacturer name}; ",
  // wifi client 離開 wifi
  ap_client_left: "Client <ClientNameWithMACAsLink> left <DeviceNameWithMACAsLink>.; Manufacturer: {Client Manufacturer name}; ",
  // device 的 ip 改變
  ap_ip_changed: "Access point <DeviceNameWithMACAsLink> IP changed to <DeviceIpAddress>.",
  // ap 的 channel 改變
  // 根據 Bug 33230 移除 Where 5G is "2.4G" or "5G" or "6G" 
  ap_radio_changed: `Access point <DeviceNameWithMACAsLink>'s <RadioBand> channel changed from <OldChannel> to <NewChannel>.`,
  // switch
  // device 上線, 由 sentry 通知
  sw_online: "Swich <DeviceNameWithMACAsLink> is now online.",
  // device 斷線, 由 sentry 通知
  sw_offline: "Swich <DeviceNameWithMACAsLink> is now offline.",
  // device 完成註冊, 由 sentry 通知
  sw_adopt: "Swich <DeviceNameWithMACAsLink> is now adopt.",
  // Device 開始執行 fw upgrade(下載fw, 寫進flash...)
  sw_firmware_progress: "Swich <DeviceNameWithMACAsLink> upgrading.",
  // Device 完成 fw upgrade 
  sw_firmware_success: "Swich <DeviceNameWithMACAsLink> upgraded to <FWver>.",
  // Device fw upgrade 失敗
  sw_firmware_fail: "Swich <DeviceNameWithMACAsLink> upgrade failed.",
  // device 的 ip 改變
  sw_ip_changed: "Switch <DeviceNameWithMACAsLink> IP changed to <DeviceIpAddress>.",
  // device port link up
  sw_port_linkup: "Port <PortNum> on switch <DeviceNameWithMACAsLink> link up.",
  // device port link down
  sw_port_linkdown: "Port <PortNum> on switch <DeviceNameWithMACAsLink> link down.",
  // device port error
  sw_port_error: "Port <PortNum> on switch <DeviceNameWithMACAsLink> reported an error. Error: <ErrorTypeString>",
  // device port error recover
  sw_port_error_recover: "Port <PortNum> on switch <DeviceNameWithMACAsLink> recovered from previous error. Error: <ErrorTypeString>",
  // device 上線, 由 sentry 通知
  proxy_online: "Proxy <DeviceNameWithMACAsLink> is now online.",
  // device 斷線, 由 sentry 通知
  proxy_offline: "Proxy <DeviceNameWithMACAsLink> is now offline.",
  // proxy ssh connections
  proxy_ssh_auth_failed: "Proxy <DeviceNameWithMACAsLink> authentication with device <PayloadDeviceNameWithMACAsLink> at IP <IP of connection destination> has failed using.",
  proxy_ssh_timeout: "Proxy <DeviceNameWithMACAsLink> connection with device <PayloadDeviceNameWithMACAsLink> at IP <IP of connection destination> has timeout.",
  proxy_ssh_reject: "Proxy <DeviceNameWithMACAsLink> connection with device <PayloadDeviceNameWithMACAsLink> at IP <IP of connection destination> has rejected.",
  proxy_ssh_failed: "Proxy <DeviceNameWithMACAsLink> connection with device <PayloadDeviceNameWithMACAsLink> at IP <IP of connection destination> has failed.",
  // device ssh connections
  device_ssh_auth_failed: "Proxy <ProxyName> authentication with device <DeviceNameWithMACAsLink> at IP <IP of connection destination> has failed using.",
  device_ssh_timeout: "Proxy <ProxyName> connection with device <DeviceNameWithMACAsLink> at IP <IP of connection destination> has timeout.",
  device_ssh_reject: "Proxy <ProxyName> connection with device <DeviceNameWithMACAsLink> at IP <IP of connection destination> has rejected.",
  device_ssh_failed: "Proxy <ProxyName> connection with device <DeviceNameWithMACAsLink> at IP <IP of connection destination> has failed.",
  // router
  // device 上線, 由 sentry 通知
  router_online: "Router <DeviceNameWithMACAsLink> is now online.",
  // device 斷線, 由 sentry 通知
  router_offline: "Router <DeviceNameWithMACAsLink> is now offline.",
  // device 完成註冊, 由 sentry 通知
  router_adopt: "Router <DeviceNameWithMACAsLink> is now adopt.",
  // Device 開始執行 fw upgrade(下載fw, 寫進flash...)
  router_firmware_progress: "Router <DeviceNameWithMACAsLink> upgrading.",
  // Device 完成 fw upgrade 
  router_firmware_success: "Router <DeviceNameWithMACAsLink> upgraded to <FWver>.",
  // Device fw upgrade 失敗
  router_firmware_fail: "Router <DeviceNameWithMACAsLink> upgrade failed.",
};

export const EVENTS_LOG_MAP = {
  // System Audit
  device_synced: { DeviceNameWithMACAsLink: "deviceName" },
  device_sync_failed: { DeviceNameWithMACAsLink: "deviceName" },
  device_fw_upgrade_schedule_create: {
    ModelName: "payload.modelName",
    NewUpgradeWindow: "payload.upgradeWindow"
  },
  device_fw_upgrade_schedule_cancel: { ModelName: "payload.modelName" },
  device_fw_upgrade_schedule_change: {
    ModelName: "payload.modelName",
    OldVersion: "payload.oldVersion",
    NewVersion: "payload.newVersion",
    NewUpgradeWindow: "payload.upgradeWindow"
  },
  invite_user_org: {
    ChangedAccountNameWithUniqueLink: "payload.changedAccountName",
    Org: "orgName",
    AccountNameWithUniqueLink: "accountName"
  },
  invite_user_site: {
    ChangedAccountNameWithUniqueLink: "payload.changedAccountName",
    Site: "siteName",
    Org: "orgName",
    AccountNameWithUniqueLink: "accountName"
  },
  remove_user_org: {
    ChangedAccountName: "payload.changedAccountName",
    Org: "orgName",
    AccountNameWithUniqueLink: "accountName"
  },
  remove_user_site: {
    ChangedAccountName: "payload.changedAccountName",
    Org: "orgName",
    Site: "siteName",
    AccountNameWithUniqueLink: "accountName"
  },
  user_leave_org: {
    ChangedAccountName: "payload.changedAccountName",
    Site: "siteName",
    Org: "orgName",
  },
  user_leave_site: {
    ChangedAccountName: "payload.changedAccountName",
    Org: "orgName",
  },
  change_user_privilege: {
    ChangedAccountNameWithUniqueLink: "payload.changedAccountName",
    AccountNameWithUniqueLink: "accountName"
  },
  captive_portal_created: {
    PortalName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  captive_portal_changed: {
    PortalName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  captive_portal_delete: {
    PortalName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  device_adopt: {
    DeviceNameWithMACAsLink: "deviceName",
    AccountNameWithUniqueLink: "accountName"
  },
  device_removed: {
    DeviceName: "deviceName",
    AccountNameWithUniqueLink: "accountName"
  },
  device_moved: {
    DeviceNameWithMACAsLink: "deviceName",
    OldSite: "siteName",
    NewSite: "payload.newSiteName",
    AccountNameWithUniqueLink: "accountName"
  },
  wireless_created: {
    WirelessNetworkName: "payload.networkName",
    AccountNameWithUniqueLink: "accountName"
  },
  wireless_deleted: {
    WirelessNetworkName: "payload.networkName",
    AccountNameWithUniqueLink: "accountName"
  },
  wireless_changed: {
    WirelessNetworkName: "payload.networkName",
    AccountNameWithUniqueLink: "accountName"
  },
  device_radio_changed: {
    DeviceNameWithMACAsLink: "deviceName",
    AccountNameWithUniqueLink: "accountName"
  },
  device_network_changed: {
    DeviceNameWithMACAsLink: "deviceName",
    AccountNameWithUniqueLink: "accountName"
  },
  org_time_zone_changed: { AccountNameWithUniqueLink: "accountName" },
  site_time_zone_changed: {
    Site: "siteName",
    AccountNameWithUniqueLink: "accountName"
  },
  device_info_changed: {
    DeviceNameWithMACAsLink: "deviceName",
    OldDeviceInfo: "payload.oldData",
    NewDeviceInfo: "payload.newData",
    AccountNameWithUniqueLink: "accountName"
  },
  wired_port_changed: {
    DeviceNameWithMACAsLink: "deviceName",
    OldWiredSettings: "payload.oldData",
    NewWiredSettings: "payload.newData",
    AccountNameWithUniqueLink: "accountName"
  },
  port_profile_changed: {
    OldPortProfile: "payload.oldData",
    NewPortProfile: "payload.newData",
    AccountNameWithUniqueLink: "accountName"
  },
  duplicated_device_connection: {
    RejectDeviceId: "payload.rejectDeviceId",
    DeviceNameWithMACAsLink: "deviceName",
    RejectDeviceIp: "payload.rejectDeviceIp",
    OldDeviceId: "payload.oldDeviceId",
    OldDeviceIp: "payload.oldDeviceIp",
  },
  // ap
  // device 上線, 由 sentry 通知
  ap_online: { DeviceNameWithMACAsLink: "deviceName" },
  // device 斷線, 由 sentry 通知
  ap_offline: { DeviceNameWithMACAsLink: "deviceName" },
  // device 完成註冊, 由 sentry 通知
  ap_adopt: { DeviceNameWithMACAsLink: "deviceName" },
  // Device開始執行fw upgrade(下載fw, 寫進flash...)
  ap_firmware_progress: { DeviceNameWithMACAsLink: "deviceName" },
  // Device 完成 fw upgrade 
  ap_firmware_success: {
    DeviceNameWithMACAsLink: "deviceName",
    FWver: "payload.version"
  },
  // Device fw upgrade 失敗
  ap_firmware_fail: { DeviceNameWithMACAsLink: "deviceName" },
  // wifi client 成功連上 wifi 後, 通過 CP 驗證
  ap_client_auth_pass: {
    ClientNameWithMACAsLink: "payload.macAddress",
    DeviceNameWithMACAsLink: "deviceName",
    Username: "payload.username",
    "Client Manufacturer name": "payload.manufacturer",
    "reasonCode": "payload.reasonCode",
  },
  // wifi client 成功連上 wifi 後, 要進行 CP 驗證的時候失敗
  ap_client_auth_fail: {
    ClientNameWithMACAsLink: "payload.macAddress",
    DeviceNameWithMACAsLink: "deviceName",
    Username: "payload.username",
    "Client Manufacturer name": "payload.manufacturer",
    "reasonCode": "payload.reasonCode"
  },
  //  wifi client 成功連上wifi
  ap_client_joined: {
    ClientNameWithMACAsLink: "payload.macAddress",
    DeviceNameWithMACAsLink: "deviceName",
    ClientIpAddress: "payload.ipAddress",
    "Client Manufacturer name": "payload.manufacturer",
    "reasonCode": "payload.reasonCode"
  },
  // 
  ap_client_ip_changed: {
    ClientNameWithMACAsLink: "payload.macAddress",
    ClientIpAddress: "payload.ipAddress",
    "Client Manufacturer name": "payload.manufacturer",
  },
  // wifi client 離開 wifi
  ap_client_left: {
    ClientNameWithMACAsLink: "payload.macAddress",
    DeviceNameWithMACAsLink: "deviceName",
    "Client Manufacturer name": "payload.manufacturer",
  },
  // device 的 ip 改變
  ap_ip_changed: {
    DeviceNameWithMACAsLink: "deviceName",
    DeviceIpAddress: "payload.ipAddress",
  },
  // ap 的 channel 改變
  ap_radio_changed: {
    DeviceNameWithMACAsLink: "deviceName",
    RadioBand: "payload.band",
    OldChannel: "payload.oldChannel",
    NewChannel: "payload.newChannel",
  },
  // switch
  // device 上線, 由 sentry 通知
  sw_online: { DeviceNameWithMACAsLink: "deviceName" },
  // device 斷線, 由 sentry 通知
  sw_offline: { DeviceNameWithMACAsLink: "deviceName" },
  // device 完成註冊, 由 sentry 通知
  sw_adopt: { DeviceNameWithMACAsLink: "deviceName" },
  // Device 開始執行 fw upgrade(下載fw, 寫進flash...)
  sw_firmware_progress: { DeviceNameWithMACAsLink: "deviceName" },
  // Device 完成 fw upgrade 
  sw_firmware_success: {
    DeviceNameWithMACAsLink: "deviceName",
    FWver: "payload.version"
  },
  // Device fw upgrade 失敗
  sw_firmware_fail: { DeviceNameWithMACAsLink: "deviceName" },
  // device 的 ip 改變
  sw_ip_changed: {
    DeviceNameWithMACAsLink: "deviceName",
    DeviceIpAddress: "payload.ipAddress"
  },
  // device port link up
  sw_port_linkup: {
    PortNum: "payload.portNum",
    DeviceNameWithMACAsLink: "deviceName"
  },
  // device port link down
  sw_port_linkdown: {
    PortNum: "payload.portNum",
    DeviceNameWithMACAsLink: "deviceName"
  },
  // device port error
  sw_port_error: {
    PortNum: "payload.portNum",
    DeviceNameWithMACAsLink: "deviceName",
    ErrorTypeString: "payload.errorType"
  },
  // device port error recover
  sw_port_error_recover: {
    PortNum: "payload.portNum",
    DeviceNameWithMACAsLink: "deviceName",
    ErrorTypeString: "payload.errorType"
  },
  // device 上線, 由 sentry 通知
  proxy_online: { DeviceNameWithMACAsLink: "deviceName" },
  // device 斷線, 由 sentry 通知
  proxy_offline: { DeviceNameWithMACAsLink: "deviceName" },
  // proxy ssh connections
  proxy_ssh_auth_failed: {
    DeviceNameWithMACAsLink: "deviceName",
    PayloadDeviceNameWithMACAsLink: "payload.deviceId",
    "IP of connection destination": "payload.ip"
  },
  proxy_ssh_timeout: {
    DeviceNameWithMACAsLink: "deviceName",
    PayloadDeviceNameWithMACAsLink: "payload.deviceId",
    "IP of connection destination": "payload.ip"
  },
  proxy_ssh_reject: {
    DeviceNameWithMACAsLink: "deviceName",
    PayloadDeviceNameWithMACAsLink: "payload.deviceId",
    "IP of connection destination": "payload.ip"
  },
  proxy_ssh_failed: {
    DeviceNameWithMACAsLink: "deviceName",
    PayloadDeviceNameWithMACAsLink: "payload.deviceId",
    "IP of connection destination": "payload.ip"
  },
  // device ssh connections
  device_ssh_auth_failed: {
    ProxyName: "payload.proxyName",
    DeviceNameWithMACAsLink: "deviceName",
    "IP of connection destination": "payload.ip"
  },
  device_ssh_timeout: {
    ProxyName: "payload.proxyName",
    DeviceNameWithMACAsLink: "deviceName",
    "IP of connection destination": "payload.ip"
  },
  device_ssh_reject: {
    ProxyName: "payload.proxyName",
    DeviceNameWithMACAsLink: "deviceName",
    "IP of connection destination": "payload.ip"
  },
  device_ssh_failed: {
    ProxyName: "payload.proxyName",
    DeviceNameWithMACAsLink: "deviceName",
    "IP of connection destination": "payload.ip"
  },
  // router
  // device 上線, 由 sentry 通知
  router_online: { DeviceNameWithMACAsLink: "deviceName" },
  // device 斷線, 由 sentry 通知
  router_offline: { DeviceNameWithMACAsLink: "deviceName" },
  // device 完成註冊, 由 sentry 通知
  router_adopt: { DeviceNameWithMACAsLink: "deviceName" },
  // Device 開始執行 fw upgrade(下載fw, 寫進flash...)
  router_firmware_progress: { DeviceNameWithMACAsLink: "deviceName" },
  // Device 完成 fw upgrade 
  router_firmware_success: {
    DeviceNameWithMACAsLink: "deviceName",
    FWver: "payload.version"
  },
  // Device fw upgrade 失敗
  router_firmware_fail: { DeviceNameWithMACAsLink: "deviceName" },
};